import { FunctionComponent, useState } from 'react'
import { useDeepCompareEffect } from 'react-use'
import styled from 'styled-components'
import PostList from '@/components/kol/common/kol-cooperation-detail-drawer/overview/post-list'
import StatisticCard from '@/components/kol/common/kol-cooperation-detail-drawer/overview/statistic-card'
import PlatformTabSelector from '@/components/kol/common/platform-tab-selector'
import useKolInfo from '@/components/kol/hooks/use-kol-info'
import type { KolActionsDropdownProps } from '@/components/kol/navigation/kol-actions-dropdown'
import { ampli } from '@/utils/ampli'
import { PlatformShortcode } from '@/utils/convert-platform'
import { convertKolInfoToKolSchemaModel } from '@/utils/kol/convert-kol-info-to-kol-schema-model'
import { getKolPlatformDatumFromLinks } from '@/utils/kol/get-kol-platform-datum-from-links'

interface OverviewProps {
  kolUuid?: string
  from?: KolActionsDropdownProps['from']
}

const Overview: FunctionComponent<OverviewProps> = ({ kolUuid, from }) => {
  const [activePlatform, setActivePlatform] = useState<PlatformShortcode>()
  const { kolInfo, isFetching, isLocked } = useKolInfo(kolUuid)

  const kolSchemaModel = kolInfo
    ? convertKolInfoToKolSchemaModel(kolInfo)
    : undefined
  const platforms = kolInfo
    ? getKolPlatformDatumFromLinks(kolInfo.links, kolInfo.kpi)
    : []

  useDeepCompareEffect(() => {
    if (platforms.length > 0) {
      setActivePlatform(platforms[0].shortcode)
    }
  }, [platforms])

  return (
    <Wrapper>
      <PlatformTabSelector
        activePlatformShortcode={activePlatform}
        handlePlatformChange={(shortcode): void => {
          ampli.changePlatform({
            kolId: kolInfo?.id,
            kolName: kolInfo?.name,
            platform: shortcode,
            from,
            isClickedFromDrawer: true,
          })
          setActivePlatform(shortcode)
        }}
        isFetching={isFetching}
        platforms={platforms}
      />
      <StatisticCard
        from={from}
        isFetching={isFetching}
        isKolInfoLocked={isLocked}
        kolInfo={kolSchemaModel}
        platformShortCode={activePlatform}
      />
      <PostList
        from={from}
        isKolFetching={isFetching}
        kolInfo={kolSchemaModel}
        platformShortCode={activePlatform}
      />
    </Wrapper>
  )
}

export default Overview

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`
